import { attachReducer } from '@redux-dynostore/core/es';
import dynamic from '@redux-dynostore/react-redux';
import { NotFound } from '@saucelabs/sl-component-error-pages';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import { useFlags } from '@saucelabs/sl-util-launchdarkly';
import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';

import Builds from './components/builds/Builds';
import { ErrorPageWrapper } from './components/common/pages/ErrorPageWrapper';
import ApolloWrapper from './global/ApolloClient';
import KeyShortcuts from './global/KeyShortcuts';
import visualReducer from './reducer';
import { useVisualDispatch } from './reduxHooks';
import { actions } from './ducks/filterBar/index';
import { VisualBuildDetailsPageNew } from './components/VisualBuildDetailsPageNew';
import { urls } from './constants';

const VisualRoutes = () => {
  const flags = useFlags();
  const history = useHistory();
  const dispatch = useVisualDispatch();

  useEffect(() => () => {
    const isVisualRoute = new RegExp('^/visual').test(history.location.pathname);
    if (!isVisualRoute) {
      dispatch(actions.setPage(1));
    }
  }, []);

  return (
    <LoginRequiredContainer>
      <SentryBoundary owner={sentryConstants.TEAMS.VISUAL}>
        <ApolloWrapper>
          <KeyShortcuts>
            <main className="flex flex-col h-full relative">
              <Switch>
                {!flags?.webUiIrisBeta && (
                  <Redirect to="/dashboard" />
                )}
                <Route
                  component={VisualBuildDetailsPageNew}
                  exact
                  path={urls.getDiff(':buildId', ':diffId')}
                />
                <Route
                  component={VisualBuildDetailsPageNew}
                  path={urls.getDiff(':buildId')}
                />
                <Route
                  component={Builds}
                  exact
                  path={urls.getBuilds()}
                />
                <Route
                  // By default, redirects from /visual -> visual/builds
                  exact
                  path="/visual"
                  render={() => (
                    <Redirect to={urls.getBuilds()} />
                  )}
                />
                <Route
                  // All other not-handled URLs are 404s instead of automatic redirects
                  render={() => (
                    <ErrorPageWrapper>
                      <NotFound
                        embedded
                      />
                    </ErrorPageWrapper>
                  )}
                />
              </Switch>
            </main>
          </KeyShortcuts>
        </ApolloWrapper>
      </SentryBoundary>
    </LoginRequiredContainer>
  );
};

// export default VisualRoutes;
export default dynamic('apps.visual', attachReducer(visualReducer))(VisualRoutes);

type VisualBuildDetailsPageParams = {
  buildId: string;
  stepId: string;
};

export {
  VisualBuildDetailsPageParams,
  urls,
};
